export const APP_NAME = 'membership_community_consume';

export const SURVICATE_KEY = '_sva';

export const SurvicateEvents = {
  SURVICATE_READY: 'SurvicateReady'
};

export const Surveys = {
  NEW_COMMENT_REPLY: '089c78835fefccac',
  LIKE_ACTION: '589ae219a5733959',
  PUBLICATION_MOTIVATION: 'aaf41d14d9843c79',
  ACESS_USER_PROFILE_IN_RANKING: '74213a9a11630e8b',
  COMMUNITY_WITHOUT_ASSOCIATION: 'befcdf2c32249a14',
  NEW_FEED: 'bc0033e379839567'
};
